//
//
//
//

/* istanbul ignore file */
export default {
  name: 'LinkDisplay',
  props: {
    value: {
      type: String,
      required: true
    }
  }
}
